import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs/Observable';
import {User} from '../models/user';
import {Angulartics2GoogleAnalytics} from 'angulartics2';

@Injectable()
export class AuthService {

  redirectUrl: string;

  /**
   * Load dependencies and set default redirect url
   * @param {ApiService} apiService
   * @param {Angulartics2GoogleAnalytics} angulartics2GoogleAnalytics
   */
  constructor(private apiService: ApiService, private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
    this.redirectUrl = '/';
  }

  /**
   * Get the current user from the API
   * @returns {Observable<User>}
   */
  getCurrentUser(): Observable<User> {
    return this.apiService.get('User/Get').map(data => new User(data.value));
  }

  /**
   * Post login to the API and return the result
   * @param {string} username
   * @param {string} password
   * @param {string} sessionToken
   * @returns {Observable<User>}
   */
  login(username: string, password: string, sessionToken: string): Observable<User> {
    return this.apiService.post('User/Login', { login: username, password: password, sessionToken: sessionToken }).map(data => {
      return new User(data.value);
    });
  }

  /**
   * Logout the user from the API and remove Google Analytics username field
   * @returns {Observable<boolean>}
   */
  logout(): Observable<boolean> {
    this.redirectUrl = '/';
    this.angulartics2GoogleAnalytics.setUsername(null);
    localStorage.clear();
    return this.apiService.post('User/Logout', {});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts